import { clamp } from "lodash";
import { useState } from "react";
import { Spinner } from "@radix-ui/themes";
import Button from "@/shared/ui/button/Button";
import { DEPOSIT_LIMIT } from "@/domains/bank/constants";
import { getFeeData } from "@/domains/bank/helpers";
import toast from "@/domains/toasts/helpers/toast";
import { useDepositMutation } from "@/domains/bank/hooks/useDepositMutation";
import { ATMInput } from "@/domains/bank/components/BankATM/components/ATMInput";
import { BankBranchCardBalance } from "@/domains/bank/components/BankBranch/components/BankBranchCardBalance";
import { BankBranchCashBalance } from "@/domains/bank/components/BankBranch/components/BankBranchCashBalance";

export function BankBranchDepositFormContainer({
  branchId,
  cardBalance,
  cashBalance,
  onCancel,
}: {
  branchId: number;
  cardBalance: number;
  cashBalance: number;
  onCancel: () => void;
}) {
  const [amount, setAmount] = useState<number>(undefined);
  const { mutate, isPending } = useDepositMutation();

  function handleAmountChange(value: string) {
    const int = Number.parseInt(value, 10);
    setAmount(clamp(int, 0, Math.min(cashBalance, DEPOSIT_LIMIT)));
  }

  function handleClose() {
    setAmount(undefined);
    onCancel();
  }

  function handleSubmit() {
    mutate(
      {
        depositAmount: amount,
        atmId: null,
        filialId: branchId,
      },
      {
        onSuccess: () => {
          toast.success("Вы пополнили свой счет!");
        },
        onError: () => {
          toast.error("Не удалось пополнить счет");
        },
      },
    );
  }

  return (
    <div className="flex flex-col gap-4 h-full">
      <button
        type="button"
        className="relative group rounded-[12px] p-6 bg-dark-800 bg-gradient-to-r from-[#162319] from-0% via-dark-800 via-40%"
      >
        <BankBranchCardBalance hideBalance={false} balance={cardBalance} className="text-left" />
      </button>

      <div>
        <div className="flex items-center justify-between text-16 font-normal my-2">
          <div className="text-white">Сумма к зачислению:</div>
          <div className="text-14 text-red">до 10 000 000 ₽</div>
        </div>

        <ATMInput
          variant="dark"
          value={amount?.toString()}
          onChange={(value) => handleAmountChange(value)}
          onMaxClick={() => setAmount(Math.min(cashBalance, DEPOSIT_LIMIT))}
        />
      </div>

      <BankBranchCashBalance balance={cashBalance} className="my-4 px-4" />

      <footer className="grid grid-cols-2 gap-2 h-[44px] mt-auto">
        <Button
          variant="solid-gradient"
          data-mz-accent="green"
          disabled={isPending || !amount}
          onClick={() => handleSubmit()}
        >
          {isPending ? <Spinner className="size-5 animate-spin" /> : "Выполнить"}
        </Button>

        <Button
          variant="solid-outline"
          data-mz-accent="green"
          className="bg-[#21a0381a] text-sbank border-none hover:bg-[#21a0381a]/12"
          onClick={() => handleClose()}
        >
          Отмена
        </Button>
      </footer>
    </div>
  );
}
